<template>
  <div>
    <b-dropdown id="account-picker" text="Select account">
      <b-dropdown-item-button
        v-for="user in userList"
        :key="user.id"
        @click="setCurrentUser(user)"
      >
        {{ user.email_address }}
      </b-dropdown-item-button>
    </b-dropdown>
  </div>
</template>

<script>
  export default {
    name: 'GMockLogin',
    computed: {
      currentUser() {
        return this.$store.getters.currentUser
      },
      userList() {
        return this.$store.getters.userList
      }
    },
    methods: {
      setCurrentUser: function(userRecord) {
        this.$store.dispatch('setCurrentUser', userRecord)
        this.$root.$bvToast.toast(
          `Successfully logged in as
      ${this.currentUser.full_name}`,
          {
            title: 'Success',
            autoHideDelay: 1000,
            toaster: 'b-toaster-top-center',
            variant: 'success'
          }
        )
        this.$router.push('/')
      }
    }
  }
</script>
